import { carouselItems } from '@/mocks/comics';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
            <p className="text-sm text-foreground-500">深度专题推荐，一站式发现好漫画</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}